import type { ReactNode } from 'react';

// Renders `current` in the normal colour with an optional muted " / initial"
// suffix. Shared by the Point-in-time stats row (UniverseStatsRow) and the
// preview card (UniversePreview) so a narrowed stat reads identically in both —
// "value out of the full universe" at a glance. `initial` null ⇒ just the
// current value (the stat isn't narrowed, so no denominator is shown).
export function statValue(current: string, initial: string | null): ReactNode {
  if (initial == null) return current;
  return (
    <>
      {current}
      <span className="text-muted-foreground font-normal">
        {' / '}
        {initial}
      </span>
    </>
  );
}
